export default "__VITE_ASSET__Dwxf_yv5__"